/* unplugin-vue-components disabled */import script from "./detailsContent.vue?vue&type=script&lang=js"
export * from "./detailsContent.vue?vue&type=script&lang=js"

import "./detailsContent.vue?vue&type=style&index=0&id=17e5fda0&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17e5fda0"]])

export default __exports__